import { $http } from "@/utils/http";
import {
    SET_ABOUT_LIST,
    SET_ABOUT_LIST_LOADING,
    SET_FAQ,
    SET_SHORT_CATEGORY_LIST,
    SET_SHORT_CATEGORY_LIST_LOADING,
} from "../mutation-types";
//
import { GET_ABOUT_LIST, GET_FAQ, GET_SHORT_CATEGORY_LIST } from "../action-types";
//
//
const state = {
    shortCategoryList: null,
    shortCategoryListLoading: false,
    aboutList: false,
    aboutListLoading: false,
    faq: "",
    //
};
//
const getters = {
    faq: state => state.faq,
    aboutList: state => state.aboutList,
    aboutListLoading: state => state.aboutListLoading,
    shortCategoryList: state => state.shortCategoryList,
    shortCategoryListLoading: state => state.shortCategoryListLoading,
};
//
const actions = {
    [GET_FAQ]: async ({ commit }) => {
        // commit(SET_ABOUT_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/faqs`);
            commit(SET_FAQ, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(SET_ABOUT_LIST_LOADING, false);
        }
    },
    [GET_ABOUT_LIST]: async ({ commit }) => {
        commit(SET_ABOUT_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/about-us`);
            commit(SET_ABOUT_LIST, response);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_ABOUT_LIST_LOADING, false);
        }
    },
    [GET_SHORT_CATEGORY_LIST]: async ({ commit }) => {
        commit(SET_SHORT_CATEGORY_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/categories/random`);
            commit(SET_SHORT_CATEGORY_LIST, response.data.data);
        } catch (e) {
            console.log(e);
            throw e;
        } finally {
            commit(SET_SHORT_CATEGORY_LIST_LOADING, false);
        }
    },
};
//
const mutations = {
    [SET_ABOUT_LIST](state, list) {
        state.aboutList = list;
    },
    [SET_ABOUT_LIST_LOADING](state, status) {
        state.aboutListLoading = status;
    },
    [SET_SHORT_CATEGORY_LIST](state, list) {
        state.shortCategoryList = list;
    },
    [SET_SHORT_CATEGORY_LIST_LOADING](state, status) {
        state.shortCategoryListLoading = status;
    },
    [SET_FAQ](state, data) {
        state.faq = data;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
